module.exports = __webpack_public_path__ + "img/5.f3466278.jpg";